import React, { useState } from "react";
import FichaDetails from "./FichaDetails";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import { Dialog } from "primereact/dialog";

function FichaPesquisa({ ficha }) {
    const [visible, setVisible] = useState(true);
    const hideDialog = () => {
        setVisible(false);

    };
    return (
            <Dialog header="Detalhes da Ficha" visible={visible} onHide={hideDialog} style={{ width: '70%' }}>
                <FichaDetails ficha={ficha} onClose={hideDialog} />
            </Dialog>
            );
}

export default FichaPesquisa;

